import React, { Component } from 'react';

import HeroSection from '../components/HeroSection';
import ProjectComponent from '../components/ProjectComponent';

import projects from '../data/projects.json';
// import misc from '../misc-projects.json';

class Work extends Component {

  constructor(props) {
    super(props);
    this.state = {
      projects: projects.data
    };
  }

  render() {
    if (!this.state.projects) return <main></main>;
    const projectsWithImages = this.state.projects.filter(p => p.images !== null);
    const projectsWithoutImages = this.state.projects.filter(p => p.images == null);

    return (
      <main>
        <HeroSection
          imageSrc="https://res.cloudinary.com/dpoz8quj5/image/upload/v1510330785/traktrek_1440w_brxw4a.jpg"
          h1="Peter Liu" h2="Web Development">
        </HeroSection>
        {(projectsWithImages.length > 0) &&
          projectsWithImages.map((project, idx) => (
            <section className="project-section" key={`wi${idx}`} style={{ backgroundColor: project.bg_style || 'none' }}>
              <ProjectComponent project={project} pid={`wi${idx}`} nextNav={true}></ProjectComponent>
            </section>
          )
        )}
        <section className="flex-section" style={{ backgroundColor: '#bba680' }}>
        {(projectsWithoutImages.length > 0) &&
          projectsWithoutImages.map((project, idx) => (
            <ProjectComponent project={project} key={idx} pid={`wo${idx}`}></ProjectComponent>
          ))
        }
        </section>
      </main>
    );
  }
}

export default Work;


// WEBPACK FOOTER //
// ./src/views/Work.js